import React from "react";
import { Button, ErrorModal, Loading, MessageBanner, } from "@folio/stripes/components";
import { useIntl } from "react-intl";
import css from "./reports.module.css";
import { ReportJobDownload } from "./ReportJobDownload";
/**
 * Shared submit section for all report forms.
 * Renders success banner, submit button with loading indicator, the download
 * button of a finished asynchronous report, and error modal.
 */
export var ReportSubmitSection = function (_a) {
    var isLoading = _a.isLoading, generateButtonId = _a.generateButtonId, successMessage = _a.successMessage, onSuccessDismiss = _a.onSuccessDismiss, errorModalOpen = _a.errorModalOpen, errorMessage = _a.errorMessage, onErrorClose = _a.onErrorClose, _b = _a.disabled, disabled = _b === void 0 ? false : _b, reportJob = _a.reportJob;
    var formatMessage = useIntl().formatMessage;
    var loadingLabelId = (reportJob === null || reportJob === void 0 ? void 0 : reportJob.isGenerating)
        ? "ui-br-agency.outputs.report-job.generating"
        : "ui-br-agency.button.generating";
    return (React.createElement(React.Fragment, null,
        successMessage && (React.createElement(MessageBanner, { type: "success", className: css.successMessage, dismissible: true, onExited: onSuccessDismiss }, successMessage)),
        React.createElement("div", { className: css.submitRow },
            React.createElement(Button, { type: "submit", buttonStyle: "primary", disabled: isLoading || disabled, marginBottom0: true }, isLoading
                ? formatMessage({ id: loadingLabelId })
                : formatMessage({ id: generateButtonId })),
            isLoading && React.createElement(Loading, null),
            React.createElement(ReportJobDownload, { reportJob: reportJob })),
        React.createElement(ErrorModal, { open: errorModalOpen, label: formatMessage({ id: "ui-br-agency.modal.label.error" }), content: errorMessage, onClose: onErrorClose })));
};
